import { useState } from "react";
import { Link } from "react-router-dom";
import ScrollReveal from "../../../components/feature/ScrollReveal";
import { useYokohamaData } from "../../../lib/useMockData";

export default function FAQPreview() {
  const { faqPreview } = useYokohamaData();
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section className="py-20 md:py-28 bg-airdoa-cream">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-12 md:mb-14">
              <p className="section-label mb-3">{faqPreview.label}</p>
              <h2 className="section-title">{faqPreview.title}</h2>
              <p className="section-subtitle max-w-2xl mx-auto">{faqPreview.subtitle}</p>
            </div>
          </ScrollReveal>

          <div className="flex flex-col gap-3">
            {faqPreview.items.map((item, idx) => (
              <ScrollReveal key={idx} direction="up" delay={idx * 80}>
                <div className="border border-airdoa-gray-light/50 rounded-lg bg-white overflow-hidden">
                  <button
                    onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                    className="w-full flex items-center justify-between p-4 md:p-5 text-left"
                  >
                    <span className="text-sm md:text-base font-medium text-airdoa-navy pr-4">
                      {item.q}
                    </span>
                    <span className="w-6 h-6 flex items-center justify-center shrink-0 text-airdoa-gold transition-transform duration-300">
                      <i className={`ri-${openIdx === idx ? "subtract" : "add"}-line text-lg`} />
                    </span>
                  </button>
                  {openIdx === idx && (
                    <div className="px-4 md:px-5 pb-4 md:pb-5">
                      <p className="text-sm text-airdoa-gray leading-[1.9]">{item.a}</p>
                    </div>
                  )}
                </div>
              </ScrollReveal>
            ))}
          </div>

          <ScrollReveal direction="up" delay={200}>
            <div className="mt-8 text-center">
              <Link to="/faq" className="btn-secondary">
                その他の質問を見る
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
